import { Icon, Label, Popup } from "semantic-ui-react";

import { Pin } from "components";
import { useCarBrandsQuery } from "modules/AppointmentDetails/hooks";
import "modules/Dayplanner/components/AppointmentCard/components/InterventionQuickView/InterventionQuickView.scss";
import { formatDurationFromMinutes } from "utils/dateHelperFunctions";

import type { Appointment, DealerLocation } from "models";
import type { ReactElement } from "react";

type InterventionQuickViewProps = {
  appointment: Appointment;
  selectedLocation: DealerLocation;
  popupTrigger: ReactElement;
};

type ReadyStatusProps = {
  isFixed: boolean;
  customerOk: boolean;
};

const ReadyStatus = ({ isFixed, customerOk }: ReadyStatusProps) => {
  return (
    <div className="mechanic-fixed-status-container">
      {isFixed && (
        <>
          <Icon className="wrench green pointer" size="small" />
          <Icon className="check circle green wrench-check-icon" />
        </>
      )}

      {!isFixed && customerOk && <Icon className="wrench solid not-fixed-wrench  rotate-270" size="small" />}
      {!isFixed && !customerOk && <Icon className="wrench regular rotate-270 grey" size="small" />}
    </div>
  );
};

export const InterventionQuickView = ({ appointment, selectedLocation, popupTrigger }: InterventionQuickViewProps) => {
  const { data: brands = [] } = useCarBrandsQuery();

  if (!appointment.interventions) return popupTrigger;

  const content = appointment.interventions.map(i => {
    const latestPin = i.pin_history?.at(0); // TODO: add latestPin as ItemWithHistory<Pin> in the select of useQuery to not have to do this and the new reference on every call of <Pin /> below

    return (
      <div className="InterventionQuickView-interventions-container" key={i.id}>
        <div className="title-description-container">
          <div className="title">{i.title}</div>
        </div>

        <div className="special-indicators-container">
          {i.labor_minutes ? (
            <span className="labor-minutes">
              <Icon className="clock" />
              {formatDurationFromMinutes(i.labor_minutes)}
            </span>
          ) : null}
          <span className="AnswerReadyStatus">
            {latestPin && <Pin pin={{ ...latestPin, history: i.pin_history ?? [] }} vin={appointment.vin_nr} location={selectedLocation} brands={brands} />}
            <Label>
              <Icon className={`${i.customer_ok ? "check circle green" : "remove circle red"}`} />
            </Label>
            <ReadyStatus isFixed={i.mechanic_fixed} customerOk={i.customer_ok} />
          </span>
        </div>
      </div>
    );
  });

  return <Popup trigger={popupTrigger} content={<div className="InterventionQuickView-content">{content}</div>} hoverable style={{ padding: "0" }} />;
};
